import React from 'react';
import { TMaterialTableColumns } from 'components/table/index.types';
import { pendingTasks as types } from '../../../../types';
import timeFormat from 'utils/time-format';
import { Col } from '../../../../components/layout/layout';
import {
    PendingTaskStatus,
    ETransactionType,
} from '../../../../types/entities/pending-tasks';
import Button from '@material-ui/core/Button';
import { TCurrentSessionData } from '../../../../types/app';
import PendingTaskReadableStatus from './components/PendingTaskReadableStatus';

const columns = ({
    onApprove,
    onReject,
    currentSessionData,
}: {
    onApprove: (args0: types.TPendingTasks) => void;
    onReject: (args0: types.TPendingTasks) => void;
    currentSessionData: TCurrentSessionData;
}): TMaterialTableColumns<types.TPendingTasks> => {
    return [
        {
            width: '100',
            key: 'id',
            title: 'No',
            render: (props) => {
                if (props.rowData.ekycId) {
                    return <span>{props.rowData.ekycId}</span>
                }
                return <span>{props.rowData.id}</span>;
            }
        },
        {
            key: 'createdAt',
            title: 'Transaction Date',
            width: '100',
            render: (props) => {
                return <span>{timeFormat(props.rowData.createdAt)}</span>;
            },
        },
        {
            key: 'transactionType',
            title: 'Task Type',
            width: '100',
            render: (props) => {
                const transactionType = (() => {
                    switch (props.rowData.transactionType) {
                        case ETransactionType.CASH_WITHDRAWAL: {
                            return 'Cash Withdrawal';
                        }
                        case ETransactionType.RESET_PIN: {
                            return 'Reset PIN';
                        }
                        case ETransactionType.UNBLOCK_USER: {
                            return 'Unblock User';
                        }
                        case ETransactionType.APPROVED_EKYC: {
                            return 'Approve EKYC';
                        }
                        case ETransactionType.REJECTED_EKYC: {
                            return 'Reject EKYC';
                        }
                        case ETransactionType.CLOSE_ACCOUNT: {
                            return 'Close Account';
                        }
                        case ETransactionType.ACTIVATE_USER: {
                            return 'Activate Account';
                        }
                        default:
                            return '';
                    }
                })();
                return <span>{transactionType}</span>;
            },
        },
        {
            width: '100',
            key: 'phoneNumber',
            title: "User's Mobile Number",
        },
        {
            width: '50',
            key: 'nexUserId',
            title: 'User ID',
        },
        {
            width: '50',
            key: 'amount',
            title: 'Amount',
        },
        {
            width: '100',
            key: 'adminMakerEmail',
            title: 'Admin Maker Email',
        },
        {
            width: '100',
            key: 'rejectReason',
            title: 'Pending Task Reject Reason',
            render: (props) => {
                return <>{props.rowData.rejectReason ?? '-'}</>;
            },
        },
        {
            width: '100',
            key: 'ekycRejectReason',
            title: 'KYC Reject Reason',
            render: (props) => {
                if (props.rowData.transactionType === ETransactionType.REJECTED_EKYC) {
                    return <>{props.rowData.ekycRejectReason}</>
                }
                return <>{'-'}</>;
            },
        },
        {
            width: '50',
            key: 'status',
            title: 'Status',
            render: (props) => (
                <PendingTaskReadableStatus rawStatus={props.rowData.status} updatedAt={props.rowData.updatedAt} />
            ),
        },
        {
            width: '50',
            title: 'Actions',
            render: (props) => {
                return currentSessionData.id !== String(props.rowData.adminId) &&
                    props.rowData.status === PendingTaskStatus.PENDING ? (
                    <Col justify={'start'}>
                        <Button
                            onClick={() => onApprove(props.rowData)}
                            variant="contained"
                            color="primary"
                        >
                            Approve
                        </Button>
                        <Button
                            onClick={() => onReject(props.rowData)}
                            variant="contained"
                            color="secondary"
                        >
                            Reject
                        </Button>
                    </Col>
                ) : (
                    <></>
                );
            },
        },
    ];
};

export default columns;
